import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreakpointsService } from 'src/app/services/breakpoints.service';

@Component({
  selector: 'app-single-tags',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './single-tags.component.html',
  styleUrls: ['./single-tags.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SingleTagsComponent {
  public singleTagsChipSetRef = viewChild.required<ElementRef>('singleTagsChipSet');
  
  public singleTagList = input.required<any[]>();
  public isOnlySingleTags = input.required<boolean>();

  private _translateService = inject(TranslateService);
  private _breakpointsService = inject(BreakpointsService);
  
  private _isMobile = computed(() => this._breakpointsService.isMobile());

  public currentLang = this._translateService.currentLang;
  public isExpanded = false;
  public isSeeMoreButtonVisible = signal(false);
  private _domIsReady = signal(false);

  checkisSeeMoreButtonVisible = effect(() => {
    if(!this._domIsReady() || !this.singleTagList().length) return;

    // wait for the custom element to fully render
    setTimeout(() => {
      const chipSetEl = this.singleTagsChipSetRef().nativeElement as HTMLElement;
      
      if(this._isMobile()) {
        this.isSeeMoreButtonVisible.set(chipSetEl.scrollHeight > 312); // mobile: 8 lines of chips
      } else {
        this.isSeeMoreButtonVisible.set(chipSetEl.scrollHeight > 72); // desktop: 2 lines of chips
      }
    }, 500);
  }, { allowSignalWrites: true });
  
  ngAfterViewInit(): void {
    this._domIsReady.set(true); 
  }
  
  public isTagNameWithBrackets(name: string): boolean {
    const regex = /\(.*?\)/;
    return regex.test(name);
  }
  
  public getTagNameWithoutBrackets(name: string): string {
    return name.replace(/\s*\(.*?\)\s*/g, '').trim();
  }
  
  public getBracketTagContent(name: string): string {
    const regex = /\((.*?)\)/;
    const match = name.match(regex);
    return match ? match[1] : '';
  }

  public handleSeeMoreClick(): void {
    const chipSetEl = this.singleTagsChipSetRef().nativeElement as HTMLElement;

    chipSetEl.style.maxHeight = !this.isExpanded 
      ? 'fit-content' 
      : this._isMobile() ? '312px' : '72px'; // mobile: 8 lines of chips; desktop: 2 lines of chips

    this.isExpanded = !this.isExpanded;
  }
}
